/**
 * Reddit-style relative labels for feed/post cards (e.g. "5 min. ago", "1 hr. ago").
 * For posts older than ~30 days, falls back to a short locale date (same idea as Reddit).
 *
 * @param {string|number|Date|null|undefined} createdAt
 * @returns {string}
 */
export function formatRelativeTime(createdAt) {
  if (createdAt == null || createdAt === "") return "";

  let d;
  try {
    d = createdAt instanceof Date ? createdAt : new Date(createdAt);
  } catch {
    return "";
  }
  if (!(d instanceof Date) || Number.isNaN(d.getTime())) return "";

  const now = Date.now();
  const diffMs = now - d.getTime();

  /** Clock skew / future timestamps: never show a full clock string on the card. */
  if (diffMs < 0) return "Just now";

  const sec = Math.floor(diffMs / 1000);
  const min = Math.floor(sec / 60);
  const hr = Math.floor(min / 60);
  const day = Math.floor(hr / 24);

  if (sec < 60) return "Just now";
  if (min < 60) return `${min} min. ago`;
  if (hr < 24) return `${hr} hr. ago`;
  if (day < 30) return day === 1 ? "1 day ago" : `${day} days ago`;

  const yNow = new Date().getFullYear();
  const y = d.getFullYear();
  try {
    return d.toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      ...(y !== yNow ? { year: "numeric" } : {}),
    });
  } catch {
    return "";
  }
}
